module.exports = __webpack_public_path__ + "static/img/product4-2.4d221b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product4-2.jpg
// module id = xWfj
// module chunks = 0